module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "size": "lg",
      "title": "Edit WordCloud",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "relative w-full h-full flex flex-col pb-5 space-y-3 px-6"
  }, [_c('div', {
    staticClass: "bg-gray-100 rounded-t border border-solid border-gray-200 w-full px-6 py-3.5 text-gray-700 text-sm"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info mr-1.5"
  }), _vm._v(" "), _c('span', [_vm._v("A refined word cloud is better. We")]), _vm._v(" "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("recommend")]), _vm._v(" removing keywords that are too generic to "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("provide relevant ")]), _vm._v("insights.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow overflow-hidden table-height mb-3 overflow-y-auto"
  }, [_c('div', {
    staticClass: "relative w-full h-full"
  }, [_c('table', {
    staticClass: "table-auto w-full"
  }, [_c('thead', {
    staticClass: "bg-gray-100 border border-solid text-sm rounded"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center w-1/12 text-sm text-gray-700 py-3"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-left py-3"
  }, [_vm._v("Keyword")]), _vm._v(" "), _c('th', {
    staticClass: "text-right px-6 w-2/12 py-3"
  }, [_vm._v("Occurrences")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "bg-white border border-solid text-gray-700 text-sm rounded"
  }, _vm._l((Object.keys(_vm.keywords)), function(word, index) {
    return _c('tr', {
      key: index,
      staticClass: "border-b"
    }, [(word !== 'l') ? _c('td', {
      staticClass: "text-center py-2 font-semibold"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": !_vm.keywords[word].removed
      },
      on: {
        "click": function($event) {
          _vm.keywords[word].removed = !_vm.keywords[word].removed
        }
      }
    })]) : _vm._e(), _vm._v(" "), (word !== 'l') ? _c('td', {
      staticClass: "py-2 cursor-pointer hover:underline",
      on: {
        "click": function($event) {
          _vm.keywords[word].removed = !_vm.keywords[word].removed
        }
      }
    }, [_vm._v("\n                " + _vm._s(word) + "\n              ")]) : _vm._e(), _vm._v(" "), (word !== 'l') ? _c('td', {
      staticClass: "text-right px-6 py-2"
    }, [_vm._v("\n                " + _vm._s(_vm.keywords[word].freq) + "\n              ")]) : _vm._e()])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-between items-center"
  }, [_c('button', {
    staticClass: "px-4 py-2 bg-gray-50 border border-solid border-gray-200 hover:bg-gray-100 rounded text-gray-800",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "px-4 py-2 bg-primary border border-solid border-primary hover:bg-primary-dark hover:border-primary-dark rounded text-white",
    on: {
      "click": function($event) {
        return _vm.handleSaveKeywrods()
      }
    }
  }, [_vm._v("Save Keywords")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5c1be6e1!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/Modals/EditVRWordCloud.vue
// module id = 1910
// module chunks = 61